<div class="toolBarcontainer">
  <div *ngIf="showConfirmbar" class="secondbar confirmbar">
    <div class="absolute">
      <button mat-mini-fab class="close">
        <mat-icon class="material-icons" (click)="showConfirmbar = false"
          >close</mat-icon
        >
      </button>
    </div>

    <button
      mat-stroked-button
      class="confirmAppel"
      (click)="appelServeur(id, callType)"
    >
      Confirmer l'appel
    </button>
  </div>

  <mat-toolbar class="toolbarNav">
   
    <div class="button-box big">
      <div class="container_action_button">
        <button (click)="setCallType('appel')" mat-fab>
          <mat-icon
            svgIcon="appel-serveur"
            aria-hidden="false"
            (click)="showConfirmbar = true"
          ></mat-icon>
        </button>
        <div class="desc">Appel serveur</div>
      </div>
      <div class="container_action_button">
        <button (click)="setCallType('eau')" mat-fab>
          <mat-icon
            svgIcon="eau"
            aria-hidden="false"
            (click)="showConfirmbar = true"
          ></mat-icon>
        </button>
        <div class="desc">Eau</div>
      </div>
      <div class="container_action_button">
        <button (click)="setCallType('pain')" mat-fab>
          <mat-icon
            svgIcon="pain"
            aria-hidden="false"
            (click)="showConfirmbar = true"
          ></mat-icon>
        </button>
        <div class="desc">Pain</div>
      </div>
      <div class="container_action_button">
        <button (click)="setCallType('selPoivre')" mat-fab>
          <mat-icon
            svgIcon="sel-poivre"
            aria-hidden="false"
            (click)="showConfirmbar = true"
          ></mat-icon>
        </button>
        <div class="desc">Sel/Poivre</div>
      </div>
      <div class="container_action_button">
        <button (click)="setCallType('payer')" mat-fab>
          <mat-icon
            svgIcon="paiement"
            aria-hidden="false"
            (click)="showConfirmbar = true"
          ></mat-icon>
        </button>
        <div class="desc">Payer</div>
      </div>
    </div>

    
  </mat-toolbar>
</div>
